import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_ENTERPRISE_ACCOUNT_SHOW_ERROR,
  ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADED,
  PATH_ENTERPRISE_ACCOUNTS
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_ENTERPRISE_ACCOUNT_SHOW_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_ENTERPRISE_ACCOUNTS}/${action.payload.id}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/EnterpriseAccountShowEpic.js